import React, { Component } from 'react'
import { safeParse } from '../utils';
const Parser = safeParse;

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openIndex: 0 // по умолчанию открыт первый элемент (индекс 0)
    }
  }

  toggleAccordion = (index) => {
    this.setState(prevState => ({
      openIndex: prevState.openIndex === index ? -1 : index
    }))
  }

  render() {
    const data = this.props?.data || {}
    const block_faq = data?.block_faq || {}
    const { openIndex } = this.state

    return (
      <div className='mt-[70px] xl:mt-[80px] tracking-[-0.04em] leading-none'>
        {/* Микроразметка FAQPage */}
        {(block_faq?.cards || []).length > 0 &&
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "mainEntity": (block_faq?.cards || []).map(elm => ({
                "@type": "Question",
                "name": elm.q,
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": elm.a
                }
              }))
            })}
          </script>
        }
        <div className='container'>
          <div className='flex items-center justify-center xl:justify-start gap-[10px] text-[14px]'>
            <div className='inline-flex items-center px-[15px] h-[38px] bg-[#F5F7F9] rounded-full gap-[5px] text-[14px] xl:text-[16px]'>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.4498 5.06879L13.9223 15.2163C13.7423 15.9738 13.0673 16.4988 12.2873 16.4988H2.43229C1.29979 16.4988 0.489806 15.3887 0.827306 14.3012L3.9848 4.16132C4.2023 3.45632 4.85481 2.96875 5.58981 2.96875H14.8148C15.5273 2.96875 16.1198 3.40375 16.3673 4.00375C16.5098 4.32625 16.5398 4.69379 16.4498 5.06879Z" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10"/>
                <path d="M12 16.5H15.585C16.5525 16.5 17.31 15.6825 17.2425 14.715L16.5 4.5" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.25781 4.78488L8.03782 1.54492" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12.2852 4.79208L12.9902 1.53711" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.77344 9H11.7734" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.02344 12H11.0234" stroke="#032432" stroke-width="1.125" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <div className='tracking-[-0.04em] text-[#032432]/60'>FAQ</div>
            </div>
          </div>
          <h2 className='font-medium mt-[30px] text-[#032432] text-[24px] xl:text-[36px] text-center xl:text-start leading-none'>{Parser(block_faq?.title)}</h2>
          <div className='mt-[10px] text-[14px] xl:text-[16px] text-center xl:text-start text-black/60 tracking-[-0.02em]'>{Parser(block_faq?.text)}</div>
          <div className='pt-[10px]'>
            {(block_faq?.cards || []).map((elm, index) => (
              <div 
                key={index}
                className='mt-[10px] bg-[#F5F7F9] rounded-[15px] p-[20px] cursor-pointer'
                onClick={() => this.toggleAccordion(index)}
              >
                <div className='flex items-center justify-between gap-[20px] text-[#032432] text-[16px] xl:text-[18px]'>
                  <h3 className='font-normal'>{elm.q}</h3>
                  <div className={`w-[30px] h-[30px] xl:w-[38px] xl:h-[38px] flex-none rounded-full flex items-center justify-center bg-white transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}>
                    <svg width="12" height="5" viewBox="0 0 12 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.25 3.75293L5.75 0.577514L11.25 3.75293" stroke="#032432" stroke-opacity="0.6"/>
                    </svg>
                  </div>
                </div>
                
                {/* Анимация для плавного появления/скрытия */}
                <div 
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-[500px] opacity-100 mt-[10px]' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className='text-[14px] xl:text-[16px] text-black/60 tracking-[-0.02em]'>
                    {Parser(elm.a)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default App